const doc = [({"ja":({"adminConstantBedType":({"bed":"ベッド", "sofaBed":"ソファベッド", "futon":"布団"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;